const COOKIE_NAME = 'webinar_form_submitted';
const COOKIE_EXPIRY_DAYS = 30;

function getCookie(name) {
    const value = "; " + document.cookie;
    const parts = value.split("; " + name + "=");
    if (parts.length === 2) {
        return parts.pop().split(";").shift();
    }
    return null;
}

function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + "; " + expires + "; path=/";
}

function checkAndRedirectIfSubmitted() {
    const videoPostUrl = window.webinarData?.video_post_url;

    if (!videoPostUrl) {
        return;
    }

    const cookieExists = getCookie(COOKIE_NAME);

    if (cookieExists) {
        // User has already submitted the form, redirect to video post
        window.location.href = videoPostUrl;
    }
}

function handleFormSubmit() {
    const videoPostUrl = window.webinarData?.video_post_url;

    if (videoPostUrl) {
        // Set cookie to remember form submission
        setCookie(COOKIE_NAME, "true", COOKIE_EXPIRY_DAYS);

        // Wait 1 second to show success message before redirecting
        setTimeout(() => {
            window.location.href = videoPostUrl;
        }, 1000);
    }
}

export default function initWebinars() {
    // Check if user has already submitted and should be redirected
    checkAndRedirectIfSubmitted();

    // Listen for HubSpot form submission
    window.addEventListener('message', function(event) {
        if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmitted') {
            handleFormSubmit();
        }
    });
}
